<template>
  <highcharts
    :options="chartOptions" />
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'Pizza',
  components: {
    highcharts: Chart
  },
  props: {
    dataChart: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: 320
        },
        title: {
          text: null
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y} ({point.percentage:.1f}%)</b>'
        },
        plotOptions: {
          pie: {
            // allowPointSelect: true,
            // cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          },
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (a) => {
                  this.expand(a.point.options.filters, a.point.options.name)
                }
              }
            }
          }
        },
        series: [{
          name: this.dataChart.metric_name,
          data: this.dataChart.series /* [{
              name: 'Edge',
              y: 4.67
          }, {
              name: 'Safari',
              y: 4.18
          }, {
              name: 'Sogou Explorer',
              y: 1.64
          }, {
              name: 'Opera',
              y: 1.6
          }, {
              name: 'QQ',
              y: 1.2
          }, {
              name: 'Other',
              y: 2.61
          }] */
        }]
      }
    }
  },
  created () {
  },
  methods: {
    expand (filters, name) {
      this.$emit('expand', { filters, name })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/Pizza.vue